import type { IColumn } from 'shared/ui/TableNew'
import { getLabelAsNumberInternationalFormat } from 'shared/lib'
import { type RowContact } from 'entities/Contacts/model/Table/RowContact'
import { getCellForName } from 'widgets/ContactEnrollment/ui/EnrollmentContactsTable'
import type { IOpenContactsDetails } from 'widgets/ContactsDetails'

export const getColumns = (onOpenContactsDetails: IOpenContactsDetails) => {
  const nameColumn: IColumn<RowContact> = {
    field: 'full_name',
    name: 'Name',
    renderRowCell: (row, _, config) =>
      getCellForName({
        row: row.origin,
        onOpenContactsDetails,
        config,
      }),
  }

  const numberColumn: IColumn<RowContact> = {
    field: 'number',
    name: 'Phone',
    renderRowCell: (row) => {
      if (!row.origin.number) return null

      return getLabelAsNumberInternationalFormat(row.origin.number)
    },
  }

  const emailColumn: IColumn<RowContact> = {
    field: 'email',
    name: 'Email',
  }

  return [nameColumn, numberColumn, emailColumn]
}
